import { gql } from "apollo-boost";

const UPDATE_CONNECT_SHOP_CHECKLIST = gql`
  mutation updateConnectShopChecklist($input: UpdateConnectShopChecklist!) {
    updateConnectShopChecklist(input: $input) {
      status
      error
      data
    }
  }
`;

export default UPDATE_CONNECT_SHOP_CHECKLIST;
